export function isSupportWebp() {
	const elem = document.createElement('canvas');
	// eslint-disable-next-line
	if (!!(elem.getContext && elem.getContext('2d'))) {
		return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
	}

	return false;
}
